import { Logger } from "../utils/logger";
import { dataAttributePrefix } from "../index";
import { DataTrackingClient } from "../core";
import EventEmitter from "events";
import YouTubePlayer from 'youtube-player';
import { XHR } from "../utils/xhr";
export class YoutubeMonitor {
    constructor() {
        this._trackingItems = [];
        this.trackedVideos = [];
        this._dataAttributePrefix = dataAttributePrefix;
        this._emitter = new EventEmitter();
        if (YoutubeMonitor._instance) {
            throw new Error("Singleton class [YoutubeMonitor] can't be instantiated more than once. Call getInstance() instead");
        }
    }
    onPlayVideo(callBack) {
        Logger.verbose("Youtube On Play - event attached.");
        this._emitter.on("play-youtube", (ev, element, elementEventData) => {
            Logger.verbose("Youtube On Play - 'play-youtube' event called ");
            callBack.call(this, ev, element, elementEventData);
        });
    }
    addItem(objTrackingItem, element) {
        this._trackingItems.push(objTrackingItem);
        this._attachYoutubeEvents(objTrackingItem, element);
    }
    addTrackedVideo(videoId) {
        this.trackedVideos.push(videoId);
    }
    getTrackingElementById(id) {
        let video = null;
        for (let i = 0; i < this.trackedVideos.length; i++) {
            if (this.trackedVideos[i] == id) {
                video = this.trackedVideos[i];
                break;
            }
        }
        ;
        return video;
    }
    getTrackedVideoById(id) {
        //let item: Nullable<string> = null;
        let item = false;
        for (let i = 0; i < this.trackedVideos.length; i++) {
            if (this.trackedVideos[i] == id) {
                //item = this.trackedVideos[i];
                item = true;
                break;
            }
        }
        ;
        return item;
    }
    static getInstance() {
        if (!YoutubeMonitor._instance) {
            YoutubeMonitor._instance = new YoutubeMonitor();
        }
        return YoutubeMonitor._instance;
    }
    _attachYoutubeEvents(trackingItem, element) {
        let youtubeUrl = '';
        let queryParams = [];
        let params;
        let found = false;
        let iFrameSrc = element.getAttribute('src');
        if (iFrameSrc) {
            let urlParts = iFrameSrc.split('?');
            youtubeUrl = urlParts[0];
            params = new URLSearchParams(urlParts[1]);
        }
        for (const [key, value] of params.entries()) {
            if (key == "enablejsapi") {
                found = true;
                if (value != "1") {
                    queryParams[key] = "1";
                }
                else {
                    queryParams[key] = value;
                }
            }
            else {
                queryParams[key] = value;
            }
        }
        if (!found) {
            queryParams['enablejsapi'] = "1";
        }
        Logger.verbose(queryParams);
        var str = [];
        for (var p in queryParams) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(queryParams[p]));
        }
        let iframe_url = youtubeUrl + '?' + str.join("&");
        Logger.verbose(iframe_url, youtubeUrl);
        element.setAttribute('src', iframe_url);
        let _self = this;
        let player = YouTubePlayer(element);
        player.on('ready', (ev) => {
            Logger.verbose("Youtube Player Ready....");
        });
        player.on('stateChange', (ev) => {
            //Logger.verbose("Youtube Video ev:");
            //Logger.verbose(ev.data); 
            /*
            -1 (unstarted)
            0 (ended)
            1 (playing)
            2 (paused)
            3 (buffering)
            5 (video cued)
            */
            if (ev.data == 1) {
                player.getCurrentTime().then((seconds) => {
                    Logger.verbose("Time: ", seconds);
                    let videoId = null;
                    if (youtubeUrl) {
                        let parts = youtubeUrl.split('/');
                        if (parts.length > 0) {
                            videoId = parts[parts.length - 1];
                        }
                    }
                    let is_already_played_and_tracked = this.getTrackedVideoById(videoId);
                    if (seconds >= 0 && seconds <= 2 && videoId && is_already_played_and_tracked == false) {
                        this.addTrackedVideo(videoId);
                        let elementId = element.getAttribute(this._dataAttributePrefix + "element-id");
                        if (!elementId) {
                            Logger.error(this._dataAttributePrefix + "element-id data attribute not found on element");
                            return;
                        }
                        // Get the item from trackElements array based on the elementId
                        //let item: Nullable<TrackingItem> = DataTrackingClient.getInstance().getTrackingElementById(parseInt(elementId));
                        if (trackingItem == null) {
                            Logger.error("Element with id (" + elementId.toString() + ") not found in elements array");
                            Logger.verbose(this._trackingItems);
                            return;
                        }
                        if (trackingItem.elementSelector == "") {
                            Logger.error("elementSelector cannot be empty");
                            return;
                        }
                        //let title_api_url = "https://www.googleapis.com/youtube/v3/videos?id=" + videoId;
                        let youtube_watch_url = 'https://youtube.com/watch?v=' + videoId;
                        let title_api_url = "https://www.youtube.com/oembed?url=" + encodeURIComponent(youtube_watch_url) + "&format=json";
                        XHR.call(title_api_url, "GET").then(function (res) {
                            let data = JSON.parse(res.response);
                            Logger.verbose('YT API - ', data);
                            let youtubeData = {};
                            youtubeData["video-title"] = data.title;
                            youtubeData["video-author-name"] = data.author_name;
                            youtubeData["video-id"] = videoId;
                            let elementEventData = DataTrackingClient.getInstance().prepareElementEventData(trackingItem, element);
                            elementEventData.youtubeData = youtubeData;
                            elementEventData.vimeoData = null;
                            _self._emitter.emit("play-youtube", ev, element, elementEventData);
                        }, function (err) {
                            Logger.error("Youtube title api Ffailed...");
                            Logger.verbose(err);
                        });
                        // api key needed 
                    }
                    else {
                        Logger.verbose("This Youtube Video Play Tracking Is Already Done.");
                    }
                });
            }
        });
    }
}
YoutubeMonitor._instance = null;
